import { AxiosPromise } from "axios";

import { get } from "@/shared/api/apiInstance";
import { ProfileResponse } from "@/shared/types";

export default function getProfile(): AxiosPromise<ProfileResponse> {
  return get("/me");
}
